<template>
  <div class="content">
    <s-location mypage title="내 정보 확인"/>

    <table class="tbl01  cont_w800">
      <colgroup>
        <col width="17%"/>
        <col/>
      </colgroup>
      <tr> <th>소속법원     </th> <td> {{ user.court0nm }} </td> </tr>
      <tr> <th>소속지원     </th> <td> {{ user.court1nm }} </td> </tr>
      <tr> <th>아이디       </th> <td> {{ user.id       }} </td> </tr>
      <tr> <th>이름         </th> <td> {{ user.name     }} </td> </tr>
      <tr> <th>현재 접속 IP </th> <td> {{ item.ip       }} </td> </tr>
      <tr> <th>로그인 시간  </th> <td> {{ item.logdt    }} </td> </tr>
    </table>
    <!-- <div class="comment_gray expcomment mt_15 cont_w800 display_in  " >
      <p class="tit">소속변호사가 증표를 구입할 경우</p>
      <li>귀 법무법인에 속해있는 변호사가 본인 계정으로 증표를 구입할 경우 해당 증표의 사용 권한은 증표를 구입한 해당 변호사에게 귀속됩니다.</li>
      <li>다만, 해당 변호사가 본인 계정으로 구입한 증표는 법무법인 마스터 계정으로도 사용할 수 있습니다(같은 법무법인 내 다른 변호사 개인 계정으로는 사용 붇가)</li>
      <li>또한, 귀 법무법인에 속해있던 변호사가 개인 계정으로 구입한 증표 중 미사용 증표는 해당 회원의 소속이 바뀔 경우 변경된 소속으로 자동전환 됩니다</li>
      <li>(회원 소속정보 변경 내역은 다음날 반영됩니다.)</li>
    </div> -->

    <!-- <div class="btn_group">
      <a v-if="!masterYn" @click="doSubmit" class="btn right" style="margin-left: 20px;">저장</a>
    </div> -->
  </div>
</template>

<style scoped>
table.tbl01 tr { height: 50px; }
table.tbl01 th { padding: 12px 0 0 0; margin: 0px; }
table.tbl01 td { text-align: left;  padding-left: 8px; }
table.tbl01 label { cursor: pointer; }
</style>

<script>
let ui
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      item   : {},
    }
  },

  computed: {
    ...mapGetters('session', ['user']),
  },

  created() {
    ui = this.$ui
    this.getData();
  },

  methods: {

    getData() {

      ui.httpGet('/mypage/myinfo', {},
        ret => {
          console.log("ret.data", ret.data);
          if (!ret.data)
            return

          const {status, msg, item} = ret.data;
          if (status == "OK") {
            console.log("로그인 폼에서 로그인 완료 처리");
            this.item = item
            return
          } else if (status == 'need_pw') {
            this.$router.push('/member/pw_confirm')
            return
          } else {
            ui.alert(msg, "오류", {color: 'red', width: 518})
          }

        }, null, v=>this.loading = false)
    },

  },
}
</script>